export default __webpack_public_path__ + "static/media/a011-startup-5.de01e2e2.svg";